module.exports = require("ref-multiple-table");